export function Smile({ className }: { className?: string }) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 7C16.4021 7 7.00004 16.402 7.00004 28C7.00004 39.598 16.4021 49 28 49C39.598 49 49 39.598 49 28C49 16.402 39.598 7 28 7ZM2.33337 28C2.33337 13.8247 13.8247 2.33334 28 2.33334C42.1753 2.33334 53.6667 13.8247 53.6667 28C53.6667 42.1753 42.1753 53.6667 28 53.6667C13.8247 53.6667 2.33337 42.1753 2.33337 28Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5261 31.2569C19.751 30.2344 18.2944 30.0292 17.2667 30.8C16.2358 31.5732 16.0269 33.0357 16.8001 34.0667L18.6667 32.6667C16.8001 34.0667 16.8006 34.0674 16.8012 34.0682L16.8024 34.0698L16.8051 34.0734L16.8115 34.0818L16.8283 34.1038L16.878 34.1674C16.9182 34.2182 16.9727 34.2856 17.0412 34.3672C17.1781 34.5303 17.3717 34.7511 17.6201 35.0103C18.1149 35.5266 18.8381 36.2067 19.7735 36.887C21.6353 38.2411 24.4405 39.6667 28.0001 39.6667C31.5596 39.6667 34.3648 38.2411 36.2266 36.887C37.162 36.2067 37.8852 35.5266 38.38 35.0103C38.6284 34.7511 38.822 34.5303 38.9589 34.3672C39.0274 34.2856 39.0819 34.2182 39.1221 34.1674L39.1718 34.1038L39.1886 34.0818L39.195 34.0734L39.1977 34.0698L39.1989 34.0682C39.1995 34.0674 39.2001 34.0667 37.3334 32.6667L39.2001 34.0667C39.9733 33.0357 39.7643 31.5732 38.7334 30.8C37.7057 30.0292 36.2491 30.2344 35.4741 31.2569L35.4632 31.2708C35.4493 31.2883 35.4229 31.3212 35.3843 31.3671C35.307 31.4593 35.1816 31.6031 35.0107 31.7814C34.667 32.14 34.1506 32.6266 33.4818 33.1129C32.1353 34.0922 30.2738 35 28.0001 35C25.7263 35 23.8648 34.0922 22.5183 33.1129C21.8495 32.6266 21.3331 32.14 20.9894 31.7814C20.8185 31.6031 20.6931 31.4593 20.6158 31.3671C20.5772 31.3212 20.5508 31.2883 20.5369 31.2708L20.5261 31.2569Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6666 21C18.6666 19.7113 19.7113 18.6667 21 18.6667H21.0233C22.312 18.6667 23.3566 19.7113 23.3566 21C23.3566 22.2887 22.312 23.3333 21.0233 23.3333H21C19.7113 23.3333 18.6666 22.2887 18.6666 21Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.6666 21C32.6666 19.7113 33.7113 18.6667 35 18.6667H35.0233C36.312 18.6667 37.3566 19.7113 37.3566 21C37.3566 22.2887 36.312 23.3333 35.0233 23.3333H35C33.7113 23.3333 32.6666 22.2887 32.6666 21Z"
        fill="currentColor"
      />
    </svg>
  )
}
